/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add javascript_pack_tag 'application' to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Imports _____________________________________________________________________
import 'bootstrap-sass'; // Bootstrap 3 jQuery plugins; the 'bootstrap' package is now Bootstrap 5
import '@/src/application.scss';
import '@/src/bs5.scss'; // Bootstrap 5, scoped under .bs5 (see postcss.config.js)
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { createBootstrap } from 'bootstrap-vue-next';
import { createConsumer } from '@rails/actioncable';
import router from '@/router';
import App from '@/app.vue';

require('@rails/ujs').start();

import "font-awesome/scss/font-awesome.scss";

import * as Sentry from '@sentry/vue';

// Application _________________________________________________________________
const pinia = createPinia();
const app = createApp(App);

// Error Reporting _____________________________________________________________
const sentryDsn = '' // TODO: <%= NewsroomQ::Sentry.public_dsn.to_json %>;
if(sentryDsn) {
  Sentry.init({
    app,
    dsn: sentryDsn,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

// Websockets
app.config.globalProperties.$cable = createConsumer();

app
  .use(pinia)
  .use(router)
  .use(createBootstrap())
  .mount('#newsroomq-app');
